/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, organisation: NonNullable<unknown> }} Guest_Visit_Banner_MemberInputs */



/**
* | output |
* | --- |
* | "You are working as {name} in {organisation}, as a member." |
*
* @param {Guest_Visit_Banner_MemberInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const guest_visit_banner_member = /** @type {((inputs: Guest_Visit_Banner_MemberInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Visit_Banner_MemberInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Je werkt als ${i?.name} in ${i?.organisation}, als lid.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Vous travaillez en tant que ${i?.name} dans ${i?.organisation}, comme membre.`)
	return /** @type {LocalizedString} */ (`You are working as ${i?.name} in ${i?.organisation}, as a member.`)
});